/* centro-candado-regalo.js — Héctor 2026-10-12: el anticaída de REGALO (variante 57201838358668, gratis por el descuento automático
   "REGALO: SHAMPOO ANTICAÍDA GRATIS") solo se queda en el carrito si hay 2+ anticanas (o 2+ anticaspa); máximo 1 regalo por promo.
   Shopify no deja condicionar ese descuento sin romper la promo 2 anticanas $1,197 (un solo descuento de producto por línea),
   por eso el candado vive aquí: revisa el carrito al cargar, tras cada cambio y antes de ir a pagar, y quita lo que sobre. */
(function () {
  if (window.__rnvCandado) return; window.__rnvCandado = 1;
  var REGALO = 57201838358668, ANTICANAS = 8017735614604, ANTICASPA = 8202560929932;
  // PROMO 15 DÍAS (Héctor 2026-10-19): del 20-oct 00:00 al 3-nov 23:59 CDMX, 2 productos cualquiera (sin exfoliantes) → 1 anticaída de regalo
  // que se agrega solo. Fuera de esas fechas vuelve la regla normal (2+ anticanas / 2+ anticaspa).
  var EXFOLIANTES = [8444216115340, 8390881312908], P_INI = Date.UTC(2026, 9, 19, 18, 0, 0), P_FIN = Date.UTC(2026, 10, 4, 5, 59, 59);
  var enPromo = function () { var t = Date.now(); return t >= P_INI && t <= P_FIN; };
  // 20% + envío gratis SOLO para quien llega dando clic en un correo de la promo (utm_campaign=promo15_*): códigos CORREO20 + CORREOENVIO
  try {
    var K15 = 'rnvPromo15';
    if (Date.now() > P_FIN) localStorage.removeItem(K15);
    else {
      if (/utm_campaign=promo15/i.test(location.search)) localStorage.setItem(K15, '1');
      if (localStorage.getItem(K15) === '1') window.fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: 'CORREOENVIO' }) });
    }
  } catch (e) {}
  var ocupado = false, timer = null;
  var _fetch = window.fetch;
  function permitidos(c) {
    var ac = 0, asp = 0, todos = 0;
    c.items.forEach(function (l) {
      if (l.product_id === ANTICANAS) ac += l.quantity; if (l.product_id === ANTICASPA) asp += l.quantity;
      if (l.variant_id !== REGALO && EXFOLIANTES.indexOf(l.product_id) < 0) todos += l.quantity;
    });
    if (enPromo()) return todos >= 2 ? 1 : 0;
    return (ac >= 2 ? 1 : 0) + (asp >= 2 ? 1 : 0);
  }
  function revisar() {
    if (ocupado) return Promise.resolve(false); ocupado = true;
    return _fetch.call(window, '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var libres = permitidos(c), cambios = {};
        c.items.forEach(function (l) {
          if (l.variant_id !== REGALO) return;
          var q = Math.min(l.quantity, libres); libres -= q;
          if (q !== l.quantity) cambios[l.key] = q;
        });
        if (!Object.keys(cambios).length) {
          var tiene = c.items.some(function (l) { return l.variant_id === REGALO; });
          if (enPromo() && libres > 0 && !tiene)
            return _fetch.call(window, '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: REGALO, quantity: 1 }] }) }).then(function () { return true; });
          return false;
        }
        return _fetch.call(window, '/cart/update.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: cambios }) })
          .then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (cambio) { ocupado = false; return cambio; });
  }
  function refrescar(cambio) {
    if (!cambio) return;
    var abierto = document.querySelector('cart-drawer.active, cart-drawer[open], .cart-drawer.is-open, .drawer.active, [data-cart-drawer].is-open');
    if (/^\/cart(\/|$)/.test(location.pathname) || abierto) location.reload();
  }
  function programar() { clearTimeout(timer); timer = setTimeout(function () { revisar().then(refrescar); }, 350); }
  var RX = /\/cart\/(add|change|update|clear)(\.js)?/;
  window.fetch = function (u) {
    var p = _fetch.apply(this, arguments);
    try { var url = typeof u === 'string' ? u : (u && u.url) || ''; if (RX.test(url)) p.then(programar, programar); } catch (e) {}
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try { if (RX.test(url)) this.addEventListener('loadend', programar); } catch (e) {}
    return _open.apply(this, arguments);
  };
  // antes de pagar: candado y luego al checkout
  document.addEventListener('submit', function (e) {
    var f = e.target, b = e.submitter;
    var aPagar = (f.getAttribute('action') || '').indexOf('/checkout') > -1 || (b && b.name === 'checkout');
    if (!aPagar || f.__rnvOk) return;
    e.preventDefault();
    revisar().then(function () { f.__rnvOk = 1; location.href = '/checkout'; });
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (!a || a.__rnvOk) return;
    e.preventDefault();
    revisar().then(function () { location.href = a.getAttribute('href'); });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar); else programar();
})();
